import { action, computed, makeObservable, observable } from 'mobx';

import { IAccessibilityStore } from '../IAccessibilityStore';

import { AccessibilityColorScheme } from './types';

export class ColorSchemeStore implements IAccessibilityStore {
  colorScheme: AccessibilityColorScheme = 'base';

  constructor() {
    makeObservable(this, {
      colorScheme: observable,

      isBaseColorScheme: computed,
      isInverseColorScheme: computed,
      isBlueColorScheme: computed,
      isBeigeColorScheme: computed,
      isGreenColorScheme: computed,

      setColorScheme: action.bound,
    });
  }

  get isBaseColorScheme(): boolean {
    return this.colorScheme === 'base';
  }

  get isInverseColorScheme(): boolean {
    return this.colorScheme === 'inverse';
  }

  get isBlueColorScheme(): boolean {
    return this.colorScheme === 'blue';
  }

  get isBeigeColorScheme(): boolean {
    return this.colorScheme === 'beige';
  }

  get isGreenColorScheme(): boolean {
    return this.colorScheme === 'green';
  }

  setColorScheme(colorScheme: AccessibilityColorScheme): void {
    this.colorScheme = colorScheme;
  }

  setColorSchemeInverse = (): void => {
    this.setColorScheme('inverse');
  };

  setColorSchemeBlue = (): void => {
    this.setColorScheme('blue');
  };

  setColorSchemeBeige = (): void => {
    this.setColorScheme('beige');
  };

  setColorSchemeGreen = (): void => {
    this.setColorScheme('green');
  };

  reset = (): void => {
    this.setColorScheme('base');
  };
}
